import classNames from "classnames";
import * as React from "react";
import { semanticColors } from "~/common/colors/colors";
import { commonClientResx as resx } from "../../resxDist/commonClientResx";
import { Highlighter } from "../highlighter";
import { Text, TextProps } from "../layout/Text";
import * as styles from "./UserName.less";

type Props = {
    name: string;
    className?: string;
    disabled?: boolean;
    isWarning?: boolean;
    isDark?: boolean;
    textForHighlight?: ComponentProps<typeof Highlighter>["textForHighlight"];
} & Pick<TextProps, "weight" | "color">;

export const UserName: React.FC<Props> = ({ name, className, disabled, textForHighlight, weight, color, isDark }) => {
    const currentColor: string = React.useMemo(() => {
        if (!disabled) {
            return color;
        }

        return isDark ? semanticColors.neutral.text.tertiaryDark : semanticColors.neutral.text.tertiary;
    }, [color, disabled, isDark]);

    return (
        <div className={classNames(className, styles.wrapper)}>
            <Highlighter
                className={"fs-block"}
                weight={weight}
                text={name}
                textForHighlight={textForHighlight}
                showTitle={true}
                color={currentColor}
                truncate={true}
            />
            {disabled && (
                <Text color={currentColor} paddingLeft={4}>
                    {resx.disabledUserText}
                </Text>
            )}
        </div>
    );
};
